// extracted by mini-css-extract-plugin
module.exports = {"data-hook-wrapper":"_1qFWO","dataHookWrapper":"_1qFWO"};